export enum PREFERENCE_KEY {
  CONSENT_BANNER = "CONSENT_BANNER",
  HIDE_ON_DASHBOARD = "HIDE_ON_DASHBOARD",
}
